export interface BrandFilterParameters {
  name: string;
  shortName: string;
}
